import { useQueryClient, useMutation } from '@tanstack/react-query';
import { axios } from '@repo/http';
import { currentUser } from '@repo/user-context/current-user';
import { getAccessToken } from '@repo/auth';
export function useUpdateUser() {
    const queryClient = useQueryClient();
    const token = getAccessToken();
    return useMutation({
        mutationFn: (params)=>axios.post("/v2/user", params),
        onSuccess: async (res)=>{
            await queryClient.invalidateQueries({
                queryKey: [
                    currentUser.current(token).queryKey[0]
                ]
            });
        }
    });
}
